import {
  AfterContentInit,
  Component,
  EventEmitter,
  inject,
  Input, NO_ERRORS_SCHEMA,
  Output, SimpleChanges,
  TemplateRef
} from '@angular/core';
import { CommonModule } from "@angular/common";
import { Router } from '@angular/router';

import { get, set, toLower, extend } from "lodash-es";

import { PropertiesPanelComponent } from "../properties-panel.component";
import {Parent} from "@wms/app/parent";
import {EventManagerService} from "@wms/app";
import {DialogService} from "@wms/services";
import { LiveWidgetSettingsService } from '@wms/app/services/liveWidgetsSettings/live-widget-settings.service';
import {isDefined, runtimeEventManager} from "@wm/core"
import { MarkupManagerService, onAccessRolesChange, TOKENS_KEYS } from "@wms/core";
import {TemplateService} from "@wms/app/properties-panel/properties-template/template-service";
import { WmsWorkspaceManagerService } from '@wms/app/workspace';

@Component({
  selector: 'wms-properties-template',
  templateUrl: './properties-template.component.html',
  styleUrls: ['./properties-template.component.less'],
  standalone: true,
  imports: [
    CommonModule
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class PropertiesTemplateComponent implements AfterContentInit {
  public templateContext: any;
  public propertyTypeslist: {[key: string]: TemplateRef<any>} = {};
  public propPanel: any;
  public templateRef: any;
  @Input() isPropPanel?: boolean;
  @Input() property: string = '';
  @Input() widgetTypeForAds: string = '';
  @Input() shadowProperties: any;
  @Input() widgetType: any;
  @Input() widgetId?: any;
  @Input() activeWidget: any;
  @Input() context: any;
  @Input() advancedSettingsMode!: boolean;
  @Input() liveWidgetSettingsService!: LiveWidgetSettingsService;

  @Output() openAdvancedSettings = new EventEmitter<any>();

  exp?: string;
  id: string;
  options: any;
  dialogService: DialogService;
  toLowerCase = toLower;
  newPropertyName: string;
  private markupManager: MarkupManagerService;
  private templateService: any;
  private wsManager: WmsWorkspaceManagerService;

  private eventManager: EventManagerService;
  private router: Router;
  constructor() {
    this.propPanel = inject(PropertiesPanelComponent);
    this.eventManager = inject(EventManagerService);
    this.dialogService = inject(DialogService);
    this.markupManager = inject(MarkupManagerService);
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.templateService = inject(TemplateService);
    this.router = inject(Router);
  }

  ngOnInit() {
    if(this.advancedSettingsMode) {
      this.propPanel = this.liveWidgetSettingsService;
    }
    if (this.context) {
      this.templateContext = this.context;
    }
    if (!this.isPropPanel) {
      // This is added as properties rendered in adv settings dialog has to be pointed to activeWidget set on template and not from propPanel
      this.propPanel.activeWidget = this.activeWidget
    }
    this.propertyTemplate(this.property);
    this.templateContext = extend({property: this.property, widgetTypeForAds: this.widgetTypeForAds,
      widgetType: this.widgetType,
      activeWidget: this.activeWidget,
      addProp: {newPropertyName: this.newPropertyName},
      addProperty: this.addProperty.bind(this),
      handlePropertyButtonClick: this.handlePropertyButtonClick.bind(this),
      handleChangeListener: this.handleChangeListener.bind(this),
      shadowPropertyChange: this.shadowPropertyChange.bind(this),
      navigateToScript: this.navigateToScript.bind(this),
      onAccessRoleModelChange: this.onAccessRoleModelChange.bind(this),
      onVariantChange: this.onVariantChange.bind(this),
      onAddVariant: this.onAddVariant.bind(this),
      onEditVariant: this.onEditVariant.bind(this),
      liveWidgetSettingsService: this.liveWidgetSettingsService,
      options: this.options,
      addButton: this.addButton.bind(this),
      addWidgets: this.addWidgets.bind(this),
      onToggleChange: this.onToggleChange.bind(this),
      propPanel: this.propPanel
    }, this.templateContext);
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['widgetType'] && changes['widgetType'].previousValue && changes['widgetType'].currentValue !== changes['widgetType'].previousValue) ||
      (changes['widgetId'] && changes['widgetId'].previousValue && changes['widgetId'].currentValue !== changes['widgetId'].previousValue)) {
      this.propertyTemplate(this.property);
    }
  }

  ngAfterContentInit() {
  }

  propertyTemplate(prop:string) {
    let type = get(this.activeWidget?.widgetProps, prop)?.type;
    let widget = get(this.activeWidget?.widgetProps, prop)?.widget;
    this.options = get(this.activeWidget?.widgetProps, prop)?.options;
    if (widget) {
      this.templateRef = this.templateService[widget];
    } else {
      this.templateRef = this.templateService[type] || this.templateService['string'];
    }
  }

  openDialogWithId(id: string) {
    this.dialogService.open(id);
  }

  closeDialogWithId(id: string) {
    this.dialogService.close(id);
  }

  handlePropertyButtonClick(property: string) {
    let activeEl = this.markupManager.getActiveCanvasEl();
    let activeWidget = this.propPanel.activeWidget.$element;
    if (activeEl) {
      const activeWidgetProxy = get(activeEl[0], 'widget');
      if (activeWidgetProxy) {
        this.propPanel.activeWidget = activeWidgetProxy;
      }
    }

    if(property !== 'advancedsettings'){
      this.propPanel.widgetPropertyChanged= true;
    }
    switch (property){
      case  'advancedsettings':
        this.openAdvancedSettings.emit();
        break;
      case "addrow":
        this.eventManager.emitOnlayoutGridRowAdd()
        break;
      case "addrowabove":
        this.eventManager.emitOnlayoutGridRowAdd( {position: 'before'});
        break;
      case "addrowbelow":
        this.eventManager.emitOnlayoutGridRowAdd( {position: 'after'});
        break;
      case "addcolumn":
        this.eventManager.emitOnlayoutGridColumnAdd();
        break;
      case "addcolumnleft":
        this.eventManager.emitOnlayoutGridColumnAdd( {position: 'before'});
        break;
      case "addcolumnright":
        this.eventManager.emitOnlayoutGridColumnAdd( {position: 'after'});
        break;
      case "additem":
        this.eventManager.emitOnCanvasAdd( {
          'parentId': activeWidget.attr('widgetid'),
          'widgetType': 'wm-linearlayoutitem'
        });
        break;
      case "additembefore":
        this.eventManager.emitOnCanvasAdd( {
          'referenceId': activeWidget.attr('widgetid'),
          'referencePos': 'before',
          'parentId': activeWidget.parent().attr('widgetid'),
          'widgetType': 'wm-linearlayoutitem',
          'widgetDefaults'  : {
            'flexgrow': activeWidget.attr('flexgrow')
          }
        });
        break;
      case "additemafter":
        this.eventManager.emitOnCanvasAdd( {
          'referenceId': activeWidget.attr('widgetid'),
          'referencePos': 'after',
          'parentId': activeWidget.parent().attr('widgetid'),
          'widgetType': 'wm-linearlayoutitem',
          'widgetDefaults'  : {
            'flexgrow': activeWidget.attr('flexgrow')
          }
        });
        break;
    }
  }

  handleChangeListener(val: any) {
    this.propPanel.shadowPropertyChange(this.property, val);
  }

  addProperty(propertyName: string) {
    let widgetName  = this.activeWidget.name;
    let widgetId = this.activeWidget.widgetId;
      this.propPanel.propertyChange(propertyName, 'Enter Value')
        let $markup = this.markupManager.getActiveMarkupEl();
    // runtimeEventManager.emit('property-change', {id: propertyName, value: this.locale.LABEL_ENTER_VALUE});
    this.newPropertyName = '';
    // let canvasDom: any = get(this.designCont, 'canvasDomComponent');
    if ($markup) {
      runtimeEventManager.getService('dynamicComponentProvider').getComponentFactoryRef(this.activeWidget.widgetId, $markup[0].outerHTML, {
        noCache: true,
        transpile: true
      }).then((response: any) => {
        this.activeWidget.widget.$element.replaceWith(response.location.nativeElement.firstChild);
        this.eventManager.emitResetActiveCanvasEl('');

        setTimeout(() => {
          this.activeWidget = null;
          runtimeEventManager.emit('set-active-widget', widgetId);
        }, 100)
      });
    }
  }

  addButton(item:any) {
    let widgetDetails: any = {parentId: this.activeWidget.widgetId, widgetType: item.widgettype};
    widgetDetails.widgetDefaults = JSON.stringify(item.defaults)
    this.eventManager.emitaddWidgetEvent({...widgetDetails, byPassUndoRedo: false, preventWidgetSelection: true});
  }

  addWidgets(item:any){
    let widgetDetails: any = {parentId: this.activeWidget.widgetId, widgetType: item.widgettype};
    widgetDetails.widgetDefaults = JSON.stringify(item.defaults)
    this.eventManager.emitOnCanvasAdd({...widgetDetails, byPassUndoRedo: false, preventWidgetSelection: true})
  }

  shadowPropertyChange(property: string, value: any) {
    if (this.context && this.context.shadowPropertyChange) {
      this.context.shadowPropertyChange(property, value);
    }
    this.propPanel.shadowPropertyChange(property, value);
  }

  navigateToScript(fnName: string) {
    runtimeEventManager.emit('navigateToScript', fnName);
  }

  onToggleChange(property: string, options: any, checked: any) {
    if (isDefined(options.onValue)) {
      this.shadowProperties[property] = checked ? options.onValue : options.offValue;
    } else {
      this.shadowProperties[property] = checked ? true : false;
    }
    this.propPanel.shadowPropertyChange(property, this.shadowProperties[property]);
  }

  onVariantChange(property: string, $event: any) {
    let ov = get(this.activeWidget, property);
    this.activeWidget.syncAppearanceVariantClasses($event.value, ov, $event.custom)
    this.propPanel.shadowPropertyChange(property, $event.value)
  }

  async onAddVariant(): Promise<void> {
    await this.saveTabContent();
    this.openStyleWsForWidget(this.activeWidget,{ 'add-variant': true });
  }

  async onEditVariant(item: any): Promise<void> {
    if (!item?.value) return;

    let variantName = item.value;
    const customVariant = item.custom; 

    if (!customVariant) {
      const [appearance, variant] = item.value.split(':') 
      if (!variant) { 
        variantName = `${appearance}:${TOKENS_KEYS.STANDARD}`;
      }
    }

    await this.saveTabContent();
    this.openStyleWsForWidget(this.activeWidget,{ variant: variantName });
  }

  private openStyleWsForWidget(activeWidget : any ,options?: Record<string, any>) {
    const widgetTokenFileName = activeWidget?.tokenFileName;
    if (!widgetTokenFileName) return;

    this.router.navigate(
      ['/', 'style', 'widgets', widgetTokenFileName],
      {
        ...(options ? { queryParams: options } : {}),
        queryParamsHandling: 'merge'
      }
    );
  }

  private async saveTabContent(): Promise<void> {
    if (!this.wsManager?.isWSDirty()) {
      return;
    }

    await new Promise<void>(resolve => {
      this.wsManager.saveActiveWs.next(() => {
        resolve();
      });
    });
  }

  onAccessRoleModelChange($event: any) {
    Promise.resolve(onAccessRolesChange(this.property, $event, this.shadowProperties[this.property])).then((data: any) => {
      this.propPanel.shadowPropertyChange(this.property, data.retVal || data);
    });
  }
}
